import React from "react";
import {
  Dialog,
  DialogTitle,
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Accepted from "../../../assets/Accepted.svg";

const ModalAccepted = ({ open, onClose, onConfirm, loading, count = 1 }) => {
  const handleConfirmClick = async () => {
    await onConfirm();
  };

  const isBulk = count > 1;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 460,
          borderRadius: 3,
          overflow: "hidden",
          p: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          pb: 0.5,
          pt: 2.5,
          px: 3,
        }}
      >
        <Typography variant="h6" fontWeight={700} color="text.primary">
          {isBulk ? "Preparar pedidos" : "Preparar pedido"}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: "text.secondary", mt: -0.5 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <Box sx={{ px: 3, pt: 1, pb: 2, textAlign: "center" }}>
        <Box
          component="img"
          src={Accepted}
          alt="Preparar"
          sx={{
            width: 160,
            height: "auto",
            maxHeight: 180,
            my: 2,
            objectFit: "contain",
          }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {isBulk
            ? `¿Confirmás que deseás preparar ${count} pedidos pendientes?`
            : "¿Confirmás que deseás preparar este pedido?"}
        </Typography>
      </Box>

      <Divider />

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1.5,
          px: 3,
          py: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            borderColor: "#cbd5e1",
            color: "#475569",
            "&:hover": {
              borderColor: "#94a3b8",
              backgroundColor: "#f8fafc",
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirmClick}
          color="primary"
          disabled={loading}
          startIcon={!loading && <CheckCircleOutlineIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
          }}
        >
          {loading
            ? isBulk
              ? "Aceptando..."
              : "Preparando..."
            : isBulk
              ? `Preparar ${count} pedidos`
              : "Confirmar"}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ModalAccepted;
